import { createFiltersOperations } from '../../common/filters/operations';
import { TEST_EMPTY_NAME_DEFAULT } from '../../../constants';
import actions from './actions';
import * as selectors from './selectors';
import * as api from './api';

const operations = {};

operations.fetchFilters = (meta) => (dispatch, getState) => {
  const params = selectors.getFetchFiltersParams(getState());

  if (meta && meta.page === 'errors') {
    params.must_have = 'exception';
  }

  if (meta?.testName) {
    params.name = meta.testName === TEST_EMPTY_NAME_DEFAULT ? '' : meta.testName;
  }

  return dispatch(actions.fetchFilters(params));
};

export default Object.assign(operations, createFiltersOperations(
  actions,
  selectors,
  operations,
  api,
));
